import { render, staticRenderFns } from "./BackgroundResponsive.vue?vue&type=template&id=50ce8388&scoped=true&"
import script from "./BackgroundResponsive.vue?vue&type=script&lang=js&"
export * from "./BackgroundResponsive.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundResponsive.vue?vue&type=style&index=0&id=50ce8388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce8388",
  null
  
)

export default component.exports